import React from 'react'
import DataBox from '@zera-admin/alice-data-box'
import EmptyState from '@zera-admin/empty-state'

import { CountOfPostTypesProps } from './types'

const CountOfPostTypes: React.FunctionComponent<CountOfPostTypesProps> = ({
  data,
}) => {
  return data && Object.keys(data).length > 0 ? (
    <DataBox
      values={[
        {
          text: data.OriginalPostCount,
          title: 'Orjinal Gönderi sayısı',
        },
        {
          text: data.QuotedPostCount,
          title: 'Alıntılanan Gönderi sayısı',
        },
        {
          text: data.RetweetPostCount,
          title: 'Retweet Gönderi sayısı',
        },
      ]}
    />
  ) : (
    <EmptyState
      title="Veri bulunamadı"
      description="Kullanıcı verisi bulunamadı"
    />
  )
}

export default CountOfPostTypes
